<template>
  <div class="footer">
    <van-tabbar v-model="currIndex" class="active_tab">
      <van-tabbar-item
        v-for="(item,index) in items"
        :key="index"
        @click="tab(index,item.name)"
      >
        <template slot="icon" slot-scope="props">
          <span :class="['iconfont',props.active ? item.iconInactive : item.iconActive]"></span>
        </template>
        <span>{{item.title}}</span>
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>
<script>
  export default {
    props: ['active'],
    data() {
      return {
        currIndex: this.active,
        items: [
          {
            name: 'home',
            title: '首页',
            iconActive: 'icon-jingqingqidai',
            iconInactive: 'icon-jingqingqidai',
          },
          {
            name: 'about',
            title: '关于',
            iconActive: 'icon-jingqingqidai',
            iconInactive: 'icon-jingqingqidai',
          },
          {
            name: 'list',
            title: '列表',
            iconActive: 'icon-jingqingqidai',
            iconInactive: 'icon-jingqingqidai',
          },
        ]
      };
    },
    methods: {
      tab(index, val) {
        this.$router.push(val);
      }
    }
  };
</script>
